/* eslint-disable @typescript-eslint/naming-convention */
import { cva } from "class-variance-authority";

export const OUTLINE_VARIANTS = [
  "light-circle-outline-primary",
  "light-circle-outline-gray",
  "light-circle-outline-error",
  "light-circle-outline-warning",
  "light-circle-outline-success",
  "light-circle-outline-blue",

  "dark-circle-outline-primary",
  "dark-circle-outline-gray",
  "dark-circle-outline-error",
  "dark-circle-outline-warning",
  "dark-circle-outline-success",
] as never;

export const CIRCLE_VARIANTS = [
  "light-circle-primary",
  "light-circle-gray",
  "light-circle-error",
  "light-circle-warning",
  "light-circle-success",
  "light-circle-blue",

  "light-circle-outline-primary",
  "light-circle-outline-gray",
  "light-circle-outline-error",
  "light-circle-outline-warning",
  "light-circle-outline-success",
  "light-circle-outline-blue",

  "dark-circle-outline-primary",
  "dark-circle-outline-gray",
  "dark-circle-outline-error",
  "dark-circle-outline-warning",
  "dark-circle-outline-success",
] as never;

export const SQUARE_VARIANTS = [
  "light-square-primary",
  "mid-square-primary",
  "dark-square-primary",

  "modern-square-primary",
] as never;

export const featureIconStyles = cva("flex items-center justify-center", {
  variants: {
    size: {
      xs: "h-6 min-h-6 w-6 min-w-6",
      sm: "h-8 min-h-8 w-8 min-w-8",
      md: "h-10 min-h-10 w-10 min-w-10",
      lg: "h-12 min-h-12 w-12 min-w-12",
      xl: "h-14 min-h-14 w-14 min-w-14",
      "2xl": "h-16 min-h-16 w-16 min-w-16",
    },
    variant: {
      "light-circle-primary": "bg-primary-90 text-primary-50",
      "light-circle-gray": "bg-neutral-90 text-neutral-50",
      "light-circle-error": "bg-error-90 text-error-60",
      "light-circle-warning": "bg-warning-95 text-warning-70",
      "light-circle-success": "bg-success-98 text-success-60",
      "light-circle-blue": "bg-tertiary-98 text-tertiary-60",

      "light-circle-outline-primary": "border-primary-95 bg-primary-90 text-primary-50",
      "light-circle-outline-gray": "border-neutral-95 bg-neutral-90 text-neutral-50",
      "light-circle-outline-error": "border-error-95 bg-error-90 text-error-60",
      "light-circle-outline-warning": "border-warning-95 bg-warning-90 text-warning-70",
      "light-circle-outline-success": "border-success-98 bg-success-95 text-success-70",
      "light-circle-outline-blue": "border-tertiary-98 bg-tertiary-95 text-tertiary-60",

      "dark-circle-outline-primary": "border-primary-30 bg-primary-40 text-white",
      "dark-circle-outline-gray": "border-neutral-30 bg-neutral-40 text-white",
      "dark-circle-outline-error": "border-error-40 bg-error-50 text-white",
      "dark-circle-outline-warning": "border-warning-60 bg-warning-70 text-white",
      "dark-circle-outline-success": "border-success-60 bg-success-70 text-white",

      "light-square-primary": "bg-primary-95 text-primary-50",
      "mid-square-primary": "bg-primary-50 text-white",
      "dark-square-primary": "bg-primary-20 text-white",

      "modern-square-primary": "border border-neutral-87 bg-white text-primary-50",
    },
  },
  compoundVariants: [
    { variant: OUTLINE_VARIANTS, size: "xs", className: "border-2" },
    { variant: OUTLINE_VARIANTS, size: "sm", className: "border-4" },
    { variant: OUTLINE_VARIANTS, size: "md", className: "border-[6px]" },
    { variant: OUTLINE_VARIANTS, size: "lg", className: "border-8" },
    { variant: OUTLINE_VARIANTS, size: "xl", className: "border-10" },
    { variant: OUTLINE_VARIANTS, size: "2xl", className: "border-10" },
    { variant: CIRCLE_VARIANTS, className: "rounded-full" },
    { variant: SQUARE_VARIANTS, size: "xs", className: "rounded-sm" },
    { variant: SQUARE_VARIANTS, size: "sm", className: "rounded" },
    { variant: SQUARE_VARIANTS, size: "md", className: "rounded-md" },
    { variant: SQUARE_VARIANTS, size: "lg", className: "rounded-lg" },
    { variant: SQUARE_VARIANTS, size: "xl", className: "rounded-xl" },
    { variant: SQUARE_VARIANTS, size: "2xl", className: "rounded-2xl" },
  ],
  defaultVariants: {
    size: "md",
    variant: "light-circle-outline-primary",
  },
});

export const iconStyles = cva("", {
  variants: {
    size: {
      xs: "size-3 min-h-3 min-w-3",
      sm: "size-4 min-h-4 min-w-4",
      md: "size-5 min-h-5 min-w-5",
      lg: "size-6 min-h-6 min-w-6",
      xl: "size-7 min-h-7 min-w-7",
      "2xl": "size-7 min-h-7 min-w-7",
    },
    style: {
      solid: "",
      outline: "",
    },
  },
  compoundVariants: [
    { style: "outline", size: "xs", className: "" },
    { style: "outline", size: "sm", className: "" },
    { style: "outline", size: "md", className: "size-4 min-h-4 min-w-4" },
    { style: "outline", size: "lg", className: "size-5 min-h-5 min-w-5" },
    { style: "outline", size: "xl", className: "size-6 min-h-6 min-w-6" },
    { style: "outline", size: "2xl", className: "size-7 min-h-7 min-w-7" },
  ],
  defaultVariants: {
    size: "md",
  },
});
